import styled from 'styled-components'

export const ButtonLinkList = styled.div`
	width: calc(100% + 32px);

	margin: 16px -16px;
`
